function isObject(item) {
  return item !== null && typeof item === "object" && item.constructor === Object;
}

export { isObject };
//# sourceMappingURL=is-object.mjs.map
